import { useEffect, useMemo, useRef, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { DecoupledEditor, EventInfo } from 'ckeditor5';

import { EDITOR_CONFIG } from './ckEditorConfig';

//styles
import 'ckeditor5/ckeditor5.css';
import './ckEditor.scss';

interface InputProps {
	value: string;
	langCode: string;
	onChange: (langCode: string, data: string) => void;
}

function CKEditorComponent({ value, langCode, onChange }: InputProps) {
	const editorContainerRef = useRef<any>(null);
	const editorMenuBarRef = useRef<any>(null);
	const editorToolbarRef = useRef<any>(null);
	const editorRef = useRef<any>(null);

	const [isLayoutReady, setIsLayoutReady] = useState<boolean>(false);
	const [content, setContent] = useState<string>('');

	useEffect(() => {
		setIsLayoutReady(true);

		return () => setIsLayoutReady(false);
	}, []);

	const { editorConfig }: any = useMemo(() => {
		if (!isLayoutReady) return {};

		return { editorConfig: EDITOR_CONFIG };
	}, [isLayoutReady]);

	const handleEditorChange = (event: EventInfo<string, unknown>, editor: DecoupledEditor) => {
		const data: string = editor.getData();
		setContent(data);
		onChange(langCode, data);
	};

	return (
		<>
			<div className="main-container">
				<div className="editor-container editor-container_document-editor editor-container_include-style" ref={editorContainerRef}>
					<div className="editor-container__menu-bar" ref={editorMenuBarRef}></div>
					<div className="editor-container__toolbar" ref={editorToolbarRef}></div>
					<div className="editor-container__editor-wrapper">
						<div className="editor-container__editor">
							<div ref={editorRef}>
								{editorConfig && (
									<CKEditor
										onReady={(editor) => {
											editorToolbarRef.current.appendChild(editor.ui.view.toolbar.element);
											editorMenuBarRef.current.appendChild(editor.ui.view.menuBarView.element);
										}}
										data={content}
										editor={DecoupledEditor}
										config={{ ...editorConfig, initialData: value }}
										onChange={handleEditorChange}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default CKEditorComponent;
